import React from 'react';
import { X, Check } from 'lucide-react';
export function UpsellTable() {
  const rows = [{
    situation: 'Conectar historia con el presente',
    without: 'Buscás noticias que no encajan',
    with: '15 casos completos con fuentes'
  }, {
    situation: 'Debate para cierre del tema',
    without: 'Improvisás preguntas',
    with: 'Debate estructurado con criterios'
  }, {
    situation: '"¿Y esto para qué sirve?"',
    without: 'Sin respuesta concreta',
    with: 'Casos reales, historia viva'
  }, {
    situation: 'Estudio de caso para evaluación',
    without: 'Lo armás el domingo',
    with: 'Evaluación por caso ya lista'
  }, {
    situation: 'Conectar agro local con historia',
    without: 'No hay material adaptado',
    with: 'Casos con realidad regional'
  }, {
    situation: 'Evidencia interdisciplinaria',
    without: 'Buscás y no encontrás',
    with: 'Articulado con Geo, Ciudadanía y Producción'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-292">
      <div className="max-w-3xl mx-auto" data-id="element-293">
        <div className="text-center mb-8" data-id="element-294">
          <h2 className="text-xl md:text-3xl font-black text-white" data-id="element-295">
            🕊️ ¿QUÉ AGREGA EL UPSELL
            <br data-id="element-296" />
            <span className="text-brand-accent neon-glow" data-id="element-297">
              "CASOS REALES DEL AGRO ARGENTINO"?
            </span>
          </h2>
        </div>

        {/* 3-column table that fits fully without scrolling */}
        <div className="rounded-xl border border-white/10 overflow-hidden bg-brand-card" data-id="element-298">
          {/* Header row */}
          <div className="grid grid-cols-3" data-id="element-299">
            <div className="px-2 py-2.5 md:px-4 md:py-3 bg-white/5 border-b border-white/10 border-r border-r-white/5" data-id="element-300">
              <p className="text-[10px] md:text-sm font-bold text-gray-300 text-center" data-id="element-301">
                Situación en el aula
              </p>
            </div>
            <div className="px-2 py-2.5 md:px-4 md:py-3 bg-red-500/10 border-b border-white/10 border-r border-r-white/5" data-id="element-302">
              <div className="flex items-center justify-center gap-1" data-id="element-303">
                <X className="w-3 h-3 md:w-4 md:h-4 text-red-400" data-id="element-304" />
                <p className="text-[10px] md:text-sm font-bold text-red-400" data-id="element-305">
                  Sin Kit
                </p>
              </div>
            </div>
            <div className="px-2 py-2.5 md:px-4 md:py-3 bg-green-500/10 border-b border-white/10" data-id="element-306">
              <div className="flex items-center justify-center gap-1" data-id="element-307">
                <Check className="w-3 h-3 md:w-4 md:h-4 text-green-400" data-id="element-308" />
                <p className="text-[10px] md:text-sm font-bold text-green-400" data-id="element-309">
                  Con Kit
                </p>
              </div>
            </div>
          </div>

          {/* Data rows */}
          {rows.map((row, i) => <div key={i} className={`grid grid-cols-3 ${i < rows.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-310">
              <div className="px-2 py-2 md:px-4 md:py-3 border-r border-white/5 flex items-center" data-id="element-311">
                <p className="text-[10px] md:text-sm text-gray-300 font-medium leading-tight" data-id="element-312">
                  {row.situation}
                </p>
              </div>
              <div className="px-2 py-2 md:px-4 md:py-3 border-r border-white/5 flex items-center bg-red-500/5" data-id="element-313">
                <p className="text-[10px] md:text-sm text-gray-500 leading-tight" data-id="element-314">
                  {row.without}
                </p>
              </div>
              <div className="px-2 py-2 md:px-4 md:py-3 flex items-center bg-green-500/5" data-id="element-315">
                <p className="text-[10px] md:text-sm text-brand-accent font-semibold leading-tight" data-id="element-316">
                  {row.with}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}